import { GameFlowSteps, ETouchpoints, IDemo } from './types'
import { createInteraction, Sessions, Demos, EventReplays } from './helpers'

export default class Receiver {
  static init(
    onSceneSetup: () => void,
    setGameState,
    setActiveDemo,
    setActiveSession,
    setActiveRobotPart,
    setModalConfig,
    setShowModal,
    setConversationId,
    setIsSession,
    setIsEventReplay,
    user,
    eventStage
  ) {
    window.addEventListener(
      'message',
      e => {
        try {
          const JSONdata = typeof e.data === 'string' ? JSON!.parse(e.data) : e.data
          switch (JSONdata!.command) {
            case 'initialised':
              if (!!onSceneSetup) {
                onSceneSetup()
              }
              break
            case 'about':
              setModalConfig({ type: 'about' })
              setShowModal(true)
              createInteraction('about', user?.email || '', 'about', 'modal', eventStage)
              break
            case 'support':
              setModalConfig({ type: 'support' })
              setShowModal(true)
              break
            case 'connect':
              setModalConfig({
                type: JSONdata!.command,
                demo: JSONdata!.param
              })
              setShowModal(true)
              break
            case 'chat':
              setConversationId(JSONdata!.param)
              break
            case 'demos':
              let newDemo: IDemo = Demos[JSONdata!.param - 1]
              if (newDemo) {
                createInteraction(newDemo.id || '', user?.email || '', 'demo', 'demo', eventStage)
                setActiveDemo(newDemo)
                setGameState(GameFlowSteps.Demo)
                setIsSession(false)
                setIsEventReplay(false)
              }
              break
            case 'robot':
              let activeRoboPart: ETouchpoints
              switch (JSONdata!.param) {
                case '1':
                  activeRoboPart = ETouchpoints.RobotFrontArms
                  break
                case '2':
                  activeRoboPart = ETouchpoints.RobotMiddle
                  break
                case '3':
                  activeRoboPart = ETouchpoints.RobotScannerBox
                  break
                default:
                  activeRoboPart = ETouchpoints.None
                  break
              }
              if (activeRoboPart) {
                createInteraction(activeRoboPart, user?.email || '', 'touchpoints', 'robot', eventStage)
                setGameState(GameFlowSteps.Robot)
                setActiveRobotPart(activeRoboPart)
              }
              break
            case 'sessions':
              let newSession: IDemo = Sessions[JSONdata!.param - 1]

              if (newSession) {
                createInteraction(newSession.id || '', user?.email || '', 'sessions', 'viewed', eventStage)
                setActiveDemo(newSession)
                // PS1 one off boolean - since Sessions and Demos are the same thing we need to set a flag to send users to the right scene when users click the back button
                setIsSession(true)
                setIsEventReplay(false)
                setGameState(GameFlowSteps.Demo)
              }
              break
            case 'eventReplay':
              let newReplay: IDemo = EventReplays[JSONdata!.param - 1]
              if (newReplay) {
                createInteraction(newReplay.id || '', user?.email || '', 'eventReplay', 'viewed', eventStage)
                setActiveDemo(newReplay)
                // PS1 one off boolean - since Sessions and Demos are the same thing we need to set a flag to send users to the right scene when users click the back button
                setIsEventReplay(true)
                setIsSession(false)
                setGameState(GameFlowSteps.Demo)
              }
              break
            default:
              return
          }
        } catch (e) {
          console.log(e)
          // handle error?
        }
      },
      false
    )
  }
}
